import type { WorkspaceResponseV2 } from '@emma/api_client/types';
import { ApplicationTable } from '@/components/application/ApplicationTable';

type Props = {
  workspace: WorkspaceResponseV2;
};

export const WorkspaceApplicationsSubPage = (props: Props) => {
  return <ApplicationTable workspace={props.workspace} />;
};
